import React from 'react';
import { ArrowRight, MapPin } from 'lucide-react';

const heroImage = '/images/projekte/neuneuneu/WhatsApp Image 2025-06-29 at 10.50.35 (4).jpeg';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative flex min-h-[calc(100svh-4rem)] items-center overflow-hidden bg-stone-950">
      <img
        src={heroImage}
        alt="Modernes, von Fliesen Jarek gefliestes Badezimmer in Cuxhaven"
        fetchPriority="high"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover object-[48%_center] sm:object-center"
      />
      <div className="absolute inset-0 bg-stone-950/25" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-r from-stone-950/90 via-stone-950/65 to-stone-950/15" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-t from-stone-950/55 via-transparent to-stone-950/15" aria-hidden="true" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-5 py-20 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-primary-100 backdrop-blur-sm">
            <MapPin className="h-4 w-4" />
            Fliesenleger in Cuxhaven
          </div>

          <h1 className="font-display text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-7xl">
            Professionelle
            <span className="block text-primary-200">Fliesenarbeiten</span>
          </h1>

          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-stone-200 sm:text-xl">
            Über 20 Jahre Erfahrung in Cuxhaven. Von der Badsanierung bis zur präzisen Verlegung – persönlich geplant und sauber ausgeführt.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={scrollToContact}
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-primary-600 px-7 py-4 font-semibold text-white shadow-lg shadow-stone-950/20 transition hover:bg-primary-500"
            >
              Kostenloses Angebot
              <ArrowRight className="h-5 w-5" />
            </button>
            <a
              href="#gallery"
              className="inline-flex items-center justify-center rounded-xl border border-white/25 bg-white/10 px-7 py-4 font-semibold text-white backdrop-blur-sm transition hover:bg-white/15"
            >
              Echte Projekte ansehen
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-5 right-5 z-10 hidden rounded-full border border-white/15 bg-stone-950/45 px-4 py-2 text-xs font-medium text-white/80 backdrop-blur-sm sm:block">
        Echtes Referenzprojekt von Fliesen Jarek
      </div>
    </section>
  );
};

export default Hero;
